import authService, { TOKEN_TYPES } from "@/services/authService";
import { ApiError } from "@/hooks/FetchHook";

/**
 * Thin fetch wrapper that auto-injects the Bearer auth token.
 * Use this for ad-hoc fetches inside useQuery / useMutation queryFns.
 * For responses that must not include auth (e.g. external APIs like
 * nominatim), call the native fetch() directly.
 */
export async function apiFetch(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  const token = authService.getToken(TOKEN_TYPES.ACCESS);

  const headers = new Headers(options.headers);
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (!headers.has("Content-Type") && options.body) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(url, { ...options, headers });

  if (!res.ok) {
    throw new ApiError(`HTTP error! status: ${res.status}`, res.status);
  }

  return res;
}

export async function apiFetchJson<T>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const res = await apiFetch(url, options);
  return res.json() as Promise<T>;
}
